/**
 * Which shows the Worker should watch.
 *
 * The app used to upload a list of episodes. That could only ever describe
 * what it knew the last time it was opened, so a season announced during a
 * fortnight away reached nobody. It uploads a list of shows instead, and the
 * Worker reads their schedules from Simkl on its own — episode schedules are
 * public, so this needs no credential to work.
 *
 * Completed shows are left out. A show that has ended and been fully watched
 * cannot announce anything, and every show included is one the Worker rechecks
 * four times a day.
 */
import { bucketOf } from "@/lib/grouping";
import type { LibraryShow } from "@/api/schemas";
import type { ShowDetail } from "@/store/details";
import type { FollowedShow } from "@/push/worker";

export function toFollowedShows(
  shows: readonly LibraryShow[],
  details: ReadonlyMap<number, ShowDetail>,
  muted: ReadonlySet<number>,
): FollowedShow[] {
  const followed: FollowedShow[] = [];
  for (const show of shows) {
    const id = show.show.ids.simkl;
    if (muted.has(id)) continue;
    if (bucketOf(show, details.get(id)?.airing) === "completed") continue;
    followed.push({ id, title: show.show.title });
  }
  return followed;
}
